import { Flex } from "@chakra-ui/react";
import { ArrowsClockwise } from "@phosphor-icons/react";

/**
 * The marker on a round header in the "Where it's used" and "Manage changed data" overlays: a small tile with
 * a cycle icon, so the dark band reads as a reporting round rather than as a count or a section heading.
 */
export default function RoundIcon() {
  return (
    <Flex
      align="center"
      justify="center"
      w="36px"
      h="36px"
      flexShrink={0}
      borderRadius="10px"
      bg="rgba(255,255,255,.1)"
      color="#B5E06C"
    >
      <ArrowsClockwise size={18} weight="bold" />
    </Flex>
  );
}
